import { createActions } from "redux-actions";

export default createActions({
  SERVICE: {
    INDEX_OF_NOT_SIGNED_IN: {
      SET: (
        isWebViewTabApp,
        circles,
        newArrivalCircles,
        events,
        blogs,
        reports,
        serviceName
      ) => ({
        isWebViewTabApp,
        circles,
        newArrivalCircles,
        events,
        blogs,
        reports,
        serviceName,
      }),
    },
  },
});
